<template>
  <div class="activeWheel-container">
    <van-nav-bar title="转盘抽红包">
      <template #left>
        <img
          class="leftImg"
          @click="$router.push('/home')"
          src="@/assets/jiantou@2x.png"
          alt=""
        />
      </template>
    </van-nav-bar>
    <div class="content-box">
      <!-- 活动规则 -->
      <div class="rulesbtn" @click="$router.push('/activityRules')">
        <img class="rulesImg" src="@/assets/zpqietu/hdgz@2x.png" alt="" />
      </div>
      <!-- 标题 -->
      <div class="titlebox">
        <img class="titleImg" src="../../assets/zpqietu/zpchb.png" alt="" />
      </div>
      <!-- 大转盘 -->
      <div class="turntable">
        <!-- 转盘图片 -->
        <div
          class="wheel-bg"
          :class="{ freeze: freeze }"
          :style="`transform: rotate(${wheelDeg}deg)`"
        >
          <div class="prize-list">
            <div
              class="prize-item-wrapper"
              v-for="(item, index) in prizeList"
              :key="index"
            >
              <div
                class="prize-item"
                :style="`transform: rotate(${
                  (360 / prizeList.length) * index
                }deg)`"
              >
                <div class="prize-name">
                  {{ item.title }}
                </div>
                <div class="prize-icon">
                  <van-image
                    fit="contain"
                    class="iconImg"
                    :src="url + item.imgurl"
                  />
                  <!-- <img :class="classList[index]" :src="url + item.imgurl" /> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 指针图片 -->
        <img
          class="turntable-pointer"
          src="@/assets/zpqietu/cj@2x.png"
          alt=""
          @click="start"
        />
      </div>
      <div class="botboxs">
        <!-- 抽奖次数 -->
        <div class="lotterys">
          <img class="lottertbgc" src="@/assets/zpqietu/bg@2x.png" alt="" />
          <div class="lottertext">{{ this.luckyDrawUser }}次抽奖机会</div>
        </div>
        <!-- 我的奖品 -->
        <img
          class="myprize"
          @click="$router.push('/myPrize')"
          src="@/assets/zpqietu/jpan@2x.png"
          alt=""
        />
        <p class="company">技术支持：杭州晨星创文网络科技有限公司</p>
      </div>
      <!-- 遮罩层(暂无抽奖次数) -->
      <div class="overlay" v-show="this.luckyDrawUser == 0">
        <van-overlay :show="isShow">
          <div class="middle">
            <van-icon
              style="float: right; font-size: 30px; margin-right: -20px"
              name="close"
              color="#fff"
              @click="ondown"
            />
            <img class="datBgc" src="@/assets/zpqietu/cxtck2@2x.png" alt="" />
            <p class="dattext" v-if="this.userIsLuckdraw == 0">
              晨星大转盘抽红包：您还未参与答题， 请先答题再来抽奖吧！
            </p>
            <p class="dattext" v-else>
              晨星大转盘抽红包：您抽奖次数已经用完，明天再来吧！
            </p>
            <!-- 去答题按钮 -->
            <div
              class="datbtnbox"
              v-show="this.userIsLuckdraw == 0"
              @click="$router.push('/home')"
            >
              <img class="datbtn" src="@/assets/zpqietu/qdt@2x.png" alt="" />
            </div>
          </div>
        </van-overlay>
      </div>
      <!-- 遮罩层(谢谢参与) -->
      <div class="overlay">
        <van-overlay :show="thankShow">
          <div class="thankmiddle">
            <van-icon
              style="float: right; font-size: 30px; margin-right: 60px"
              name="close"
              color="#fff"
              @click="ondown"
            />
            <img class="thankBgc" src="@/assets/zpqietu/hyh@2x.png" alt="" />
          </div>
        </van-overlay>
      </div>
      <!-- 遮罩层（实物） -->
      <div class="overlay">
        <van-overlay :show="profileShow">
          <div class="profilemiddle">
            <van-icon
              style="float: right; font-size: 30px; margin-right: 30px"
              name="close"
              color="#fff"
              @click="ondown"
            />
            <img
              class="profileBgc"
              src="@/assets/zpqietu/swtck@2x.png"
              alt=""
            />
            <!-- 图片 -->
            <van-image
              fit="contain"
              class="nethook"
              :src="url + this.results.imgurl"
            />
            <!-- <img class="nethook" :src="url + this.results.imgurl" alt="" /> -->
            <img class="trapezoid" src="@/assets/zpqietu/wzi@2x.png" alt="" />
            <h5>恭喜获得{{ this.results.title }}</h5>
            <!-- 开心收下 -->
            <img
              @click="ondown"
              class="profilebtn"
              src="@/assets/zpqietu/kxsx@2x.png"
              alt=""
            />
          </div>
        </van-overlay>
      </div>
      <!-- 遮罩层（红包） -->
      <div class="overlay">
        <van-overlay :show="envelopeShow">
          <div>
            <img
              class="envelopeBgc"
              src="@/assets/zpqietu/hbtck2@2x.png"
              alt=""
            />
            <div class="contain">
              <span class="money">{{ this.results.amountStr }}<em>元</em></span>
              <van-icon
                style="float: right; font-size: 30px; margin-right: 30px"
                name="close"
                color="#fff"
                @click="ondown"
              />
              <h4>{{ this.results.title }}</h4>
              <!-- 开心收下 -->
              <img
                @click="goPage()"
                class="envelopebtn"
                src="@/assets/zpqietu/kxsx@2x.png"
                alt=""
              />
            </div>
          </div>
        </van-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import Common from "@/components/comm";
import { getTurntable, luckDraw } from "@/api/new";
import md5 from "js-md5";
import JSNO from "json-bigint";
// md5('holle')  // bcecb35d0a12baad472fbe0392bcc043
export default {
  name: "activeWheel",
  components: {},
  props: {},
  inject: ["reload"], //注入App里的reload方法
  data() {
    return {
      url: Common.getUrl(),
      isShow: false, //暂无抽奖次数
      thankShow: false, //谢谢参与
      profileShow: false, //实物
      envelopeShow: false, //红包
      freeze: false, //转盘执行转态
      rolling: false, //抽奖执行状态，防止用户多次点击
      wheelDeg: 0, //指针将要旋转的度数
      prizeNumber: 8, //转盘平分份数
      prizeListOrigin: [],
      classList: [
        "onething",
        "twothing",
        "threething",
        "fourthing",
        "fivething",
        "sixthing",
        "severthing",
        "eightthing",
      ],
      luckyDrawUser: "", //抽奖次数
      timestamp: "", //时间戳
      nonceStr: "", //随机字符串
      signature: "", //签名
      type: "", //奖品类型
      results: "", //中奖结果
      winningId: "", //中奖id
      pIndex: 0, //中奖下标
      clickNum: "",
      userIsLuckdraw: 0, //今天是否参与过抽奖 0没有参与过
       hongbaoLink: "",
    };
  },
  computed: {
    prizeList() {
      return this.prizeListOrigin.slice(0, this.prizeNumber);
    },
  },
  watch: {
    prizeNumber() {
      this.freeze = true;
      this.wheelDeg = 0;

      setTimeout(() => {
        this.freeze = false;
      }, 0);
    },
  },
  created() {
    this.getTurntables();
  },
  mounted() {},
  methods: {
    // 生成随机字符串
    randomString(e) {
      e = e || 32;
      var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
        a = t.length,
        n = "";
      for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
      return n;
    },
    // 获取转盘数据
    async getTurntables() {
      const { data: res } = await getTurntable();
      this.prizeListOrigin = res.data.prizeList;
      this.luckyDrawUser = res.data.luckyDrawUser;
      this.userIsLuckdraw = res.data.userIsLuckdraw;
    },
    // 抽奖
    async luckDraws() {
      this.timestamp = Date.parse(new Date());
      this.nonceStr = this.randomString(6);
      this.signature = {
        actionId: Number(this.$Cookies.get("ActionId")),
        userId: Number(this.$Cookies.get("auth")),
        timestamp: this.timestamp,
        nonceStr: this.nonceStr,
      };
      let signature = JSNO.stringify(this.signature);
      let datas = {
        timestamp: this.timestamp, //返回当前时间的事件戳
        nonceStr: this.nonceStr,
        signature: md5(md5(signature)),
      };
      const { data: res } = await luckDraw(this.$qs.stringify(datas));
      if (res.code == 200) {
        this.results = res.data;
        this.type = res.data.type;
        this.winningId = res.data.id;
      } else if (res.code == 6212) {
        // this.rolling = true;
        this.isShow = true;
      } else {
        this.freeze = true;
        Toast.fail("网络繁忙");
      }
    },
    //点击开始
    async start() {
      if (this.luckyDrawUser == 0) {
        //抽奖次数
        this.isShow = true;
      } else {
        if (this.rolling) {
          return; //false
        }
        await this.luckDraws();
        this.rolling = true;
        const { wheelDeg, prizeList } = this;

        prizeList.forEach((item, i) => {
          let arrId = JSNO.stringify(item.id);
          // 判断中奖id是否存在
          let temp = arrId.indexOf(this.winningId);
          if (temp > -1) {
            this.pIndex = i;
            this.wheelDeg =
              wheelDeg -
              (wheelDeg % 360) +
              8 * 360 +
              (360 - (360 / prizeList.length) * this.pIndex);
          }
        });
        // 取得介于 1 到 数组长度之间的一个随机数
        // Math.random():获取0~1随机数
        // Math.floor取整数
        // this.pIndex = Math.floor(Math.random() * prizeList.length);//获奖的下标
        // console.log(this.pIndex, "下标");
        setTimeout(() => {
          this.rolling = false; //抽奖执行状态
          if (this.type == 1) {
               this.hongbaoLink = this.results.hongBaoUrl;
            this.envelopeShow = true;
          } else if (this.type == 2) {
            this.profileShow = true;
          } else if (this.type == 9) {
            this.thankShow = true;
          } else {
            this.envelopeShow = false;
            this.profileShow = false;
            this.thankShow = false;
          }
        }, 5000);
      }
    },
    // 点击弹出框收下或关闭事件
    ondown() {
      this.reload(); //页面刷新
    },
    // 收下红包跳转外部链接事件
    goPage() {
       if (this.hongbaoLink) {
        window.location.href = this.hongbaoLink;
      } else {
        this.reload();
      }
    },
  },
};
</script>

<style scoped lang="less">
.content-box {
  width: 100%;
  height: calc(100vh - 92px);
  background: url("../../assets/zpqietu/zhuanpan@2X.png") no-repeat;
  background-size: 100% 100%;
  overflow-x: hidden;
}
.leftImg {
  width: 27px;
  height: 44px;
}
.rulesImg {
  float: right;
  width: 176px;
  height: 74px;
  margin-top: 20px;
}
.datBgc {
  width: 439px;
  height: 384px;
}
.middle {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  // width: 439px;
}
.dattext {
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 24px;
  font-weight: bold;
  color: #87260b;
  width: 368px;
  line-height: 50px;
  text-align: center;
}
.datbtnbox {
  position: absolute;
  bottom: -40px;
  left: 50%;
  transform: translateX(-50%);
}
.datbtn {
  width: 224px;
  height: 88px;
}
.thankmiddle {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}
.thankBgc {
  width: 737px;
  height: 544px;
}
.profilemiddle {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.profileBgc {
  position: relative;
  width: 649px;
  height: 677px;
}
.nethook {
  position: absolute;
  bottom: 200px;
  left: 51%;
  transform: translateX(-50%);
  height: 130px;
  width: 140px;
}
.trapezoid {
  position: absolute;
  bottom: 120px;
  left: 50%;
  transform: translateX(-50%);
  width: 348px;
  height: 65px;
}
h5 {
  position: absolute;
  bottom: 140px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  font-weight: 500;
  color: #ffe5c0;
  letter-spacing: 2px;
}
.profilebtn {
  width: 343px;
  height: 94px;
  position: absolute;
  bottom: -10%;
  left: 50%;
  transform: translateX(-50%);
}
.envelopemiddle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.envelopeBgc {
  position: relative;
  width: 100vw;
  height: 100vh;
}
.contain {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 650px;
}
h4 {
  position: absolute;
  top: 62%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 28px;
  font-weight: bold;
  color: #fcc450;
  line-height: 199px;
  text-shadow: 0px 2px 0px #ff1b12;
  letter-spacing: 3px;
}
.money {
  position: absolute;
  top: 27%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 60px;
  font-weight: bold;
  color: #ff411e;
}
em {
  font-style: normal;
  font-size: 30px;
}
.envelopebtn {
  width: 343px;
  height: 94px;
  position: absolute;
  bottom: -5%;
  left: 50%;
  transform: translateX(-50%);
}
.turntable {
  position: relative;
  width: 100%;
  margin-top: 55px;
}
.turntable-wheelbgc {
  width: 549px;
  height: 549px;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  margin: auto;
  transform: rotate(0deg);
  z-index: 12;
  transition: all 5s ease-in;
}
@keyframes rotateArc {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(3600deg);
  }
}
.turntable-pointer {
  width: 133px;
  height: 190px;
  position: absolute;
  top: 155px;
  right: 0px;
  left: 0;
  margin: auto;
  z-index: 1;
}
.botboxs {
  position: relative;
  width: 100%;
  height: 310px;
}
.lotterys {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  width: 393px;
}
.lottertbgc {
  position: relative;
  width: 393px;
  height: 58px;
}
.lottertext {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 26px;
  font-weight: 500;
  color: #ffdf9c;
  width: 100%;
  line-height: 58px;
  text-align: center;
}
.myprize {
  position: absolute;
  top: 130px;
  left: 50%;
  transform: translateX(-50%);
  width: 270px;
  height: 96px;
}
.company {
  position: absolute;
  bottom: 10%;
  left: 52%;
  transform: translateX(-50%);
  width: 100%;
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  color: #ffdf9c;
}
strong {
  color: #ffcc00;
}
.titlebox {
  width: 100%;
  height: 100px;
  margin: 0 auto;
  margin-top: 120px;
  text-align: center;
}
.titleImg {
  width: 550px;
  height: 81px;
}
.wheel-bg {
  margin: 0 auto;
  width: 549px;
  height: 549px;
  border-radius: 1000px;
  overflow: hidden;
  transition: all 5s ease;
  background: url("../../assets/zpqietu/dt@2x.png") no-repeat center center;
  background-size: cover;
}
.freeze {
  transition: none;
}
.prize-list {
  width: 100%;
  height: 100%;
  position: relative;
  text-align: center;
}
.prize-item-wrapper {
  position: absolute;
  top: 50px;
  left: 37%;
  transform: translate(-50%, -50%);
  width: 150px;
  height: 150px;
  transform: rotate(2deg);
}
.prize-item {
  margin: 0 auto;
  width: 100%;
  height: 150%;
  transform-origin: bottom;
}
.prize-name {
  padding: 7px 0;
  font-size: 20px;
  color: #c2824a;
}
// .prize-icon{
//   width: 57px;
//   height: 57px;
// }
.iconImg {
  width: 60px;
  height: 60px;
}

// .onething {
//   width: 57px;
//   height: 57px;
// }
// .twothing {
//   width: 57px;
//   height: 57px;
// }
// .threething {
//   width: 57px;
//   height: 57px;
// }
// .fourthing {
//   width: 54px;
//   height: 54px;
// }
// .fivething {
//   width: 61px;
//   height: 60px;
// }
// .sixthing {
//   width: 48px;
//   height: 63px;
// }
// .severthing {
//   width: 38px;
//   height: 67px;
// }
// .eightthing {
//   width: 60px;
//   height: 44px;
// }
</style>